import { render } from "./EditImage.vue?vue&type=template&id=75bfdf6f"
const script = {}
script.render = render

export default script